import { graphql } from "@/graphql/codegen/gql"

graphql(`
  query GetProductInventoryList($input: InventoryByProductListInput) {
    inventory {
      listByProduct(input: $input) {
        __typename
        ... on InventoryByProductListSuccess {
          items {
            product {
              productId
              companyProductDescription
              vendorDescription
              publicId
              externalSystemId
              computedProductStatus
              versionId
              versionNumber
              versions {
                id
                versionNumber
                status
                releaseDate
              }
            }
            ...InventoryQuantityFields
            onHoldQty
            inventoryStatus
            warehouses {
              warehouseId
              warehouseArea {
                ...WarehouseAreaBaseFields
              }
              qtyOnHand
              numPallets
            }
          }
          pageInfo {
            ...PageInfoFields
          }
        }
        ... on InventoryByProductListFailure {
          error {
            message
          }
        }
      }
    }
  }
`)

graphql(`
  query GetProductInventorySuggestionList($input: InventoryByProductListInput) {
    inventory {
      listByProduct(input: $input) {
        __typename
        ... on InventoryByProductListSuccess {
          items {
            product {
              productId
              publicId
              companyProductDescription
              externalSystemId
            }
          }
        }
        ... on InventoryByProductListFailure {
          error {
            message
          }
        }
      }
    }
  }
`)

graphql(`
  query GetProductInventoryDetail($productId: Int!) {
    inventory {
      listByProduct(input: { filter: { productId: $productId } }) {
        __typename
        ... on InventoryByProductListSuccess {
          items {
            product {
              productId
              companyProductDescription
              isActive
              versionStatus
              versionId
              versions {
                id
                versionNumber
                status
                releaseDate
              }
              publicId
              externalSystemId
              vendorDescription
              vendorSku
              company {
                ...CompanyBaseFields
              }
              classification {
                classificationId
                name
                productManager {
                  userId
                  firstName
                  lastName
                }
              }
              shelfLifeDays
              packageUsWeight
              packageUsWeightUom
              packageUsWeightUomDetails {
                name
              }
              packagingType
              palletUsWeight
              palletUsWeightUom
              specificGravity
              usmcaClass
              countryOrigin {
                country {
                  name
                }
              }
              harmonizedTariffSchedule
              freightItem
              freightClass
            }
            ...InventoryQuantityFields
            warehouses {
              warehouseId
              warehouseArea {
                ...WarehouseAreaBaseFields
              }
              qtyOnHand
              numPallets
              availableQty
              softAllocatedQty
              hardAllocatedQty
              balToCome
              moh
              mohInStock
            }
          }
        }
        ... on InventoryByProductListFailure {
          error {
            message
          }
        }
      }
    }
  }
`)

graphql(`
  query GetProductInventoryByLot($input: InventoryByLotListInput!) {
    inventory {
      listByLot(input: $input) {
        __typename
        ... on InventoryByLotListSuccess {
          items {
            lotNumber
            batchNumber
            packageSize
            warehouseId
            warehouseArea {
              ...WarehouseAreaBaseFields
            }
            qtyOnHand
            qtyOnHold
            hardAllocatedQty
            availableQty
            expireDate
            status
          }
          pageInfo {
            ...PageInfoFields
          }
        }
        ... on InventoryByLotListFailure {
          error {
            message
          }
        }
      }
    }
  }
`)

graphql(`
  query GetProductInventoryByTransaction($input: InventoryByTransactionListInput!) {
    inventory {
      listByTransaction(input: $input) {
        __typename
        ... on InventoryByTransactionListSuccess {
          items {
            warehouseId
            warehouseArea {
              ...WarehouseAreaBaseFields
            }
            createdOn
            supplier
            companyId
            orderNumber
            status
            inOutDate
            inboundWeight
            outboundWeight
            type
            price
            margin
          }
          pageInfo {
            ...PageInfoFields
          }
        }
        ... on InventoryByTransactionListFailure {
          error {
            message
          }
        }
      }
    }
  }
`)

graphql(`
  query GetProductInventoryByPallet($input: InventoryByPalletListInput!) {
    inventory {
      listByPallet(input: $input) {
        __typename
        ... on InventoryByPalletListSuccess {
          items {
            referenceNbr
            totalUom
            laidDownCost
            location
            lots {
              lotNumber
              batchNumber
              lotUom
              remainingShelfLife
              packageUom
              packageDesc
              status
            }
          }
          pageInfo {
            ...PageInfoFields
          }
        }
        ... on InventoryByPalletListFailure {
          error {
            message
          }
        }
      }
    }
  }
`)

graphql(`
  query GetProductInventoryPalletGroups($input: InventoryPalletGroupsInput!) {
    inventory {
      listPalletGroups(input: $input) {
        __typename
        ... on InventoryPalletGroupsSuccess {
          items {
            referenceNbr
            location
            totalQoh
            lots {
              rawInventoryId
              lotNbr
              batchNbr
              packageDesc
              totalPackages
              packageSize
              totalUnits
              uom
              qaStatus
              manufacturingDate
              expirationDate
              hasProductTest
              isLocked
            }
          }
          pageInfo {
            ...PageInfoFields
          }
        }
        ... on InventoryPalletGroupsFailure {
          error {
            message
          }
        }
      }
    }
  }
`)

graphql(`
  query GetProductInventoryAdjustments($input: InventoryAdjustmentListByProductInput!) {
    inventoryAdjustment {
      listByProduct(input: $input) {
        __typename
        ... on InventoryAdjustmentListSuccess {
          items {
            inventoryAdjustmentId
            adjustmentType
            status
          }
        }
        ... on InventoryAdjustmentListFailure {
          error {
            message
          }
        }
      }
    }
  }
`)
